export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-8">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <p className="m-0 text-gray-400 text-xs mb-1">v{__APP_VERSION__}</p>
        <p className="m-0 text-gray-500 text-sm">Powered by Odin © 2026</p>
      </div>
    </footer>
  )
}